export default "__VITE_ASSET__G9qNSxmI__"